import React from 'react';
import styled from 'styled-components/macro';

import { zIndex } from '@mirinae/react-ui';

import { wikinaeSize } from '@mirinae/wikinae/modules/defines/styles';
import { MobileHeaderButton } from '@mirinae/wikinae/components/common/header/HeaderButton';

const Search = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: ${props => (props.theme === 'header' ? 'fit-content' : '100%')};
    height: ${props => (props.theme === 'header' ? '30px' : '50px')};
    
    ${props => (props.theme !== 'header' && `
        @media only screen and (max-width: ${wikinaeSize.breakpoint.sm}) {
            width: 100%;
        }
    `)}
`;

export default Search;

export const SearchExpand = styled.div`
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    gap: 0 10px;

    & > button {
        flex-shrink: 0;
        width: 34px;
        height: 34px;
    }
`;

const SearchLayerWrapper = styled.div`
    position: fixed;
    inset: 0;
    z-index: ${zIndex.header};
    background: url('/assets/wikinae/images/bg-body.png') 50%;
    overflow: auto;

    & > button {
        z-index: ${zIndex.header + 1};
    }
`;
const SearchLayerInner = styled.div`
    position: relative;
    margin: 0 10px;
    padding: 77px 20px 50px;
`;

export const SearchLayer = (props) => (
    <SearchLayerWrapper>
        <MobileHeaderButton theme="back" onClick={() => props.onClose()} />
        <SearchLayerInner>
            {props.children}
        </SearchLayerInner>
    </SearchLayerWrapper>
);